
<template>
  <div>
    <v-combobox
      v-model="selected"
      :disabled="disabled"
      :loading="loading"
      :filter="(e) => {return true;}"
      :items="items"
      :search-input.sync="search"
      hide-no-data
      hide-details
      item-text="description"
      :clearable="true"
      :label="label"
      :hint="hint"
      persistent-hint
    >
      <template v-slot:selection="{ attrs, item}">
        <span class="pr-2 body-2" v-text="item.description"></span>
      </template>
      <template v-slot:item="{ attrs, item}" v-on="on">
          <v-list-item-icon style="margin-right: 1em;">
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <!-- <v-list-item-title class="body-2" v-text="item.description"></v-list-item-title>-->
            <span class="pr-2 body-2" v-text="item.description"></span>
          </v-list-item-content>
        <!-- <span class="pr-2 body-2" v-text="item.description" style="border-bottom: 1px solid grey;"></span> -->
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Es wurden keine Ergebnisse für "
              <strong>{{ search }}</strong>" gefunden.
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
  </div>
</template>

<script>
export default {
  name: "GooglePlaceAutocomplete",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      required: false
    }
  },
  data: function() {
    return {
      ownChangeEvent: false,
      loading: false,
      items: [],
      selected: null,
      searchTimeoutId: undefined,
      search: null
    };
  },
  computed: {},
  watch: {
    value: function(val) {
      if ((this.selected && !val) || (!this.selected && val)) {
        this.ownChangeEvent = true;
        this.selected = val;
        this.ownChangeEvent = false;
        return;
      }
      if (this.selected && val && this.selected.place_id != val.place_id) {
        this.ownChangeEvent = true;
        this.selected = val;
        this.ownChangeEvent = false;
        return;
      }
      // console.log('Ignoring new value')
    },
    search(val) {
      val && val !== this.selected && this.querySelections(val);
    },
    selected: function() {
      if (!this.ownChangeEvent) {
        this.$emit("input", this.selected);
      }
    }
  },
  mounted() {
    this.ownChangeEvent = true;
    this.selected = this.value;
    this.ownChangeEvent = false;
  },
  methods: {
    querySelections(v) {
      let input = v;
      if (this.searchTimeoutId) {
        clearTimeout(this.searchTimeoutId);
        this.searchTimeoutId = undefined;
      }
      this.searchTimeoutId = setTimeout(() => {
        // console.log('Timeout triggered', input);
        this.searchPlaces(input);
      }, 500);
    },
    searchPlaces(v) {
      if (!v || v.trim() == "") {
        return;
      }
      this.loading = true;
      this.$api
        .getPlacesAutocomplete(v)
        .then(res => {
          this.loading = false;
          this.items = res.data.predictions ? res.data.predictions : [];
          // console.log(res.data);
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    }
  }
};
</script>